export const en = {
  seeError: 'See error',
  retry: 'Retry',
  couldntSend: 'Task could not be sent',
  errorTitle: 'Error details'
};

export type Translations = typeof en;
